import { reactive } from "vue";
const context = reactive({})


export const defineAction = (name, config = { execute: (v) => { return v } }) => {
    if (!name) {
        return
    }
    context[name] = config
}

export const getAction = (name) => {
    return context[name]
}